/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { withNamespaces } from 'react-i18next';
import defaultsDeep from 'lodash/defaultsDeep';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import HeroComponent from './Hero';
import FullWidthGrid from './FullWidthGrid';
import Grid from './Grid';
import defaultData from './data.json';
import { get } from 'lodash';

export class Shop extends SafePureComponent {
  fields = {};
  constructor(props) {
    super(props);
  }

  componentDidMount = () => {
    document.querySelector('body').style.background = '#f4f3f0';
  };

  renderHeroComponent = () => {
    const Title = get(this.fields, 'ShopData.Title', '');
    const Subtitle = get(this.fields, 'ShopData.Subtitle', '');

    return <HeroComponent Title={Title} Subtitle={Subtitle} />;
  };

  lowerFirstLetter = string => {
    return string.charAt(0).toLowerCase() + string.slice(1);
  };

  getContentBlock = () => {
    const ShopDataRows = get(this.fields, 'ShopData.Rows', []);

    let LocationInformation = get(this.fields, 'LocationInformation', {});
    // icon.value.src = 'http://regus.dev.local/' + icon.value.src;
    let tempLocationInformation = { ...LocationInformation };
    for (const keyInfo in LocationInformation) {
      tempLocationInformation[this.lowerFirstLetter(keyInfo)] =
        LocationInformation[keyInfo];
    }

    return ShopDataRows.map((row, index) => {
      switch (row.ShopCards.length) {
        case 1:
          return row.ShopCards.map((cardData, ShopCardIndex) => (
            <FullWidthGrid
              blockData={cardData}
              key={`ShopCardIndex-${ShopCardIndex}`}
              LocationInformation={tempLocationInformation}
            />
          ));
          break;

        case 2:
        case 3:
          return (
            <Grid
              blockData={row.ShopCards}
              LocationInformation={tempLocationInformation}
            />
          );
          break;

        default:
          return false;
          break;
      }
    });
  };

  safeRender() {
    // const fields = defaultData;?
    this.fields = defaultsDeep(this.props.fields, defaultData.fields);
    // console.log('** this.fields', this.fields);
    return (
      <React.Fragment>
        {this.renderHeroComponent()}

        {this.getContentBlock()}
      </React.Fragment>
    );
  }
}

Shop.displayName = 'Shop';

export default withNamespaces()(Shop);
